import { useSuspenseQuery } from '@tanstack/react-query'

import { GetProdutosDisponiveisService } from '@/features/simulador/brasil/http'
import type { TTipoProdutoPrecificadoBrasilEnum } from '@/types/produto'
import { produtosKeys } from '@/utils/produtos-query-keys'

export const useSuspenseProdutosDisponiveis = (
  idExternoBloco: number,
  tipoDoProduto: TTipoProdutoPrecificadoBrasilEnum,
  simulacaoId: string,
) => {
  return useSuspenseQuery({
    queryKey: produtosKeys.disponiveis(idExternoBloco, tipoDoProduto, simulacaoId),
    queryFn: async () =>
      new GetProdutosDisponiveisService().execute(idExternoBloco, tipoDoProduto).then((res) => res.data),
    staleTime: Infinity,
  })
}
